// Generated by ReScript, PLEASE EDIT WITH CARE


function isUpperPlace(placeClass) {
  if (typeof placeClass !== "object") {
    return placeClass === "PlaceClassVertical";
  }
  if (placeClass.TAG !== "PlaceClassGutter") {
    return false;
  }
  switch (placeClass._0) {
    case "GutterUpper" :
      return true;
    case "GutterLower" :
    case "GutterAngled" :
      return false;
  }
}

export {
  isUpperPlace,
}
/* No side effect */
